<template>
  <el-card class="widget-container">
    <!-- Sección de Filtros -->

    <el-form
      :model="filters"
      inline
      class="date-form"
    >
      <el-form-item label="Fecha">
        <el-date-picker
          v-model="filters.dateRange"
          type="daterange"
          unlink-panels
          range-separator="Hasta"
          start-placeholder="Desde"
          end-placeholder="Hasta"
          :shortcuts="shortcuts"
          :size="size"
          format="DD/MM/YYYY"
        />
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="applyFilters"
        >
          Aplicar Filtros
        </el-button>
      </el-form-item>
    </el-form>

    <!-- Sección de Widgets -->
    <slot :filters="confirmedFilters" />
  </el-card>
</template>

<script setup>
import {
  ref,
  reactive,
} from 'vue';

const shortcuts = [
  {
    text: 'Ultima semana',
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      return [start, end];
    },
  },
  {
    text: 'Ultimo mes',
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      return [start, end];
    },
  },
  {
    text: 'Ultimos 3 meses',
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      return [start, end];
    },
  },
  {
    text: 'Ultimo año',
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
      return [start, end];
    },
  },
];

const filters = reactive({
  dateRange: shortcuts[1].value(),
});

const confirmedFilters = ref({ ...filters });

const applyFilters = () => {
  confirmedFilters.value = { ...filters };
};
</script>

<style scoped>
.widget-container {
  padding: 16px;
}

.date-form {
  padding: 10px;
}

@media (max-width: 767px) {
  .widget-container {
    padding: 4px;
  }

  .date-form {
    padding: 4px;
  }

  /* Filtro de fecha y botón a todo el ancho, apilados */
  .date-form :deep(.el-form-item) {
    display: flex;
    width: 100%;
    margin-right: 0;
  }

  .date-form :deep(.el-form-item__content),
  .date-form :deep(.el-date-editor) {
    width: 100%;
    flex: 1;
  }

  .date-form :deep(.el-button) {
    width: 100%;
  }
}
</style>
